import React, { useState } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Home from './components/Home';
import About from './components/About';
import Services from './components/Services';
import Approach from './components/Approach';
import Fees from './components/Fees';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const [activePage, setActivePage] = useState('home');

  return (
    <div className="app-shell">
      <Navbar activePage={activePage} onNavigate={setActivePage} />
      <main className="page-main">
        <section id="home" className={`page-section${activePage === 'home' ? ' active' : ''}`}>
          <Home onNavigate={setActivePage} />
        </section>
        <section id="about" className={`page-section${activePage === 'about' ? ' active' : ''}`}>
          <About onNavigate={setActivePage} />
        </section>
        <section id="services" className={`page-section${activePage === 'services' ? ' active' : ''}`}>
          <Services />
        </section>
        <section id="approach" className={`page-section${activePage === 'approach' ? ' active' : ''}`}>
          <Approach />
        </section>
        <section id="fees" className={`page-section${activePage === 'fees' ? ' active' : ''}`}>
          <Fees onNavigate={setActivePage} />
        </section>
        <section id="contact" className={`page-section${activePage === 'contact' ? ' active' : ''}`}>
          <Contact />
        </section>
      </main>
      <Footer onNavigate={setActivePage} />
    </div>
  );
}

export default App;